export enum BaseDomainType {
  GENERAL = 'general',
  SUPPLIER = 'supplier',
  COMPANY = 'company',
  CONTRACT = 'contract',
  ORDER = 'order',
  COMMODITY = 'commodity',
  COMMODITY_GROUP = 'commodityGroup',
  DATA_FOUNDATION = 'dataFoundation',
  PURCHASE_REQUISITION = 'purchaseRequisition',
  SETTINGS = 'settings',
  INTERNAL_TOOLS = 'internalTools',
  SOURCING_PROJECT = 'sourcingProject',
}
export type BaseDomain = `${BaseDomainType}`;

export enum BaseDetailDomainType {
  // Used on Entity Record Detail Pages
  CONTRACT_DETAILS = 'contractDetails',
  PURCHASE_REQUISITION_DETAILS = 'purchaseRequisitionDetails',
  PURCHASE_ORDER_DETAILS = 'purchaseOrderDetails',
  // Combined item List over multiple records
  PURCHASE_ORDER_ITEM_DETAILS = 'purchaseOrderItemDetails',
  SOURCING_PROJECT_DETAILS = 'sourcingProjectDetails',
  COVERAGE_ASSISTANT = 'coverageAssistant',
}
export type BaseDetailDomain = `${BaseDetailDomainType}`;

export enum NegotiationDomainType {
  CASE = 'case',
  NEGOTIATION_CASE = 'negotiation-case',
  DEMAND = 'demand',
  DEMAND_CASES = 'demandCases',
  CONTRACT_DEMAND = 'contractDemand',
  CONTRACT_DEMAND_REQUEST = 'contractDemandRequest',
  CONTRACT_DEMAND_CASES = 'contractDemandCases',
  SOURCING_CASE_QUOTE = 'sourcingCaseQuote',
}

export type NegotiationDomain = `${NegotiationDomainType}`;
export enum IntakeDomainType {
  INTAKE = 'intake',
}
export type IntakeDomain = `${IntakeDomainType}`;

export enum RuleDomainType {
  RULE_SOURCING = 'ruleSourcing',
}
export type RuleDomain = `${RuleDomainType}`;

export enum KnowledgeGraphDomainType {
  KNOWLEDGE_GRAPH = 'knowledge-graph',
}

export type KnowledgeGraphDomain = `${KnowledgeGraphDomainType}`;

export enum KnowledgeRepositoryDomainType {
  PROCUREMENT_KNOWLEDGE = 'procurement-knowledge',
}

export type KnowledgeRepositoryDomain = `${KnowledgeRepositoryDomainType}`;

export enum UserDomainType {
  USER_AVAILABILITY = 'userAvailability',
  SIGN_OUT = 'signOut',
}
export type UserDomain = `${UserDomainType}`;

export enum TenantDomainType {
  ACCOUNTING_DETAILS_LIST = 'accountingDetailsList',
  ACCOUNTING_ASSET_LIST = 'accountingAssetList',
  COMMODITY_GROUP_LIST = 'commodityGroupList',
  COMMODITY_LIST = 'coreCommodityList',
  COMPANY_LIST = 'companyList',
  LOCATION_LIST = 'locationList',
  SAVINGS_LIST = 'savingsList',
  DEMAND_PROJECT_LIST = 'demandProjectList',
  DOCUMENT = 'document',
  EMAIL = 'email',
  GL_ACCOUNT_LIST = 'glAccountList',
  INTERNAL_ORDER_LIST = 'internalOrderList',
  ORDER_CONFIRMATION = 'orderConfirmation',
  ORGANIZATIONAL_UNIT = 'organizationalUnit',
  PURCHASE_ORDER = 'purchaseOrder',
  UNIT_LIST = 'unitList',
  WORK_PACKAGE_LIST = 'workPackageList',
}
export type TenantDomain = `${TenantDomainType}`;

export enum DataAccessManagementDomainType {
  TEAMS_MANAGEMENT = 'teamsManagement',
}
export type DataAccessManagementDomain = `${DataAccessManagementDomainType}`;

//
// -----  CAUTION  ------
// be aware that the domain entries need to be unique across the different domains
// as it will be used for saving user config etc.
//
export type Domain =
  | BaseDomain
  | NegotiationDomain
  | BaseDetailDomain
  | IntakeDomain
  | KnowledgeGraphDomain
  | KnowledgeRepositoryDomain
  | UserDomain
  | RuleDomain
  | TenantDomain
  | DataAccessManagementDomain;
